import { Component, effect, ElementRef, inject, Signal, signal, viewChild, WritableSignal } from '@angular/core';
import { ColorService } from '../../services/color.service';
import { TranslateModule } from '@ngx-translate/core';
import { ProfileService } from '../../services/profile.service';
import { Dropdown } from '../../directives/dropdown.directive';
import { FoldState } from '../../types/fold-state.type';
import { IconComponent, SkeletonComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { SearchService } from '../../services/search.service';
import { GuidedTourService } from '../../services/guided-tour-service';
import { HttpResourceRef } from '@angular/common/http';
import { LoginService } from '../../services/login.service';
import { AnalyticsService } from '../../services/analytics.service';
import { NotificationDropdown } from '../notification-dropdown/notification-dropdown';

@Component({
  selector: 'app-nav-bar',
  imports: [IconComponent, TranslateModule, Dropdown, SkeletonComponent, NotificationDropdown],
  templateUrl: './nav-bar.html',
  styleUrl: './nav-bar.scss',
})
export class NavBar {
  private readonly profileService: ProfileService = inject(ProfileService);
  protected readonly loginService: LoginService = inject(LoginService);
  protected readonly analyticsService: AnalyticsService = inject(AnalyticsService);
  protected colorService: ColorService = inject(ColorService);
  protected searchService: SearchService = inject(SearchService);
  protected guidedTourService: GuidedTourService = inject(GuidedTourService);
  protected textColor$ = this.colorService.textColor();
  userMenu = viewChild.required('notificationsMenu', { read: ElementRef<HTMLDivElement> });
  notificationsMenu = viewChild.required('notificationsMenu', { read: ElementRef<HTMLDivElement> });
  userMenustate = signal<FoldState>('fold');
  notificationsMenustate = signal<FoldState>('fold');

  public guidedTourHover: WritableSignal<boolean> = signal(false);
  protected readonly profileRessources: HttpResourceRef<any | undefined> = this.profileService.profileRessources;

  clientRoles: Signal<string[]> = this.profileService.roles;

  toggleNotificationsMenuState(): void {
    if (this.notificationsMenustate() === 'fold') {
      this.notificationsMenustate.set('unfold');
      this.notificationsMenu().nativeElement.style.zIndex = '1001';
      return;
    }
    this.notificationsMenustate.set('fold');
    this.notificationsMenu().nativeElement.style.zIndex = '1';
  }

  toggleUserMenuState(): void {
    if (this.userMenustate() === 'fold') {
      this.userMenustate.set('unfold');
      this.userMenu().nativeElement.style.zIndex = '1001';
      return;
    }
    this.userMenustate.set('fold');
    this.userMenu().nativeElement.style.zIndex = '1';
  }

  onUserMenuStateChange(newState: FoldState): void {
    this.userMenustate.set(newState);
    if (newState === 'fold') {
      this.userMenu().nativeElement.style.zIndex = '1';
    }
  }

  onNotificationsMenuStateChange(newState: FoldState): void {
    this.notificationsMenustate.set(newState);
    if (newState === 'fold') {
      this.userMenu().nativeElement.style.zIndex = '1';
    }
  }
}
